import { render, staticRenderFns } from "./HomeSlides.vue?vue&type=template&id=75afef86&scoped=true&"
import script from "./HomeSlides.vue?vue&type=script&lang=js&"
export * from "./HomeSlides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75afef86",
  null
  
)

export default component.exports